import { CircularProgress } from '@mui/material';

import { CenteredLayout } from '../layouts';

export const LoadingScreen = () => {
  return (
    <CenteredLayout height='100vh'>
      <CircularProgress />
    </CenteredLayout>
  );
};
